import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@material-ui/core';

export const OkButton = ({ ...props }) => (
  <Button {...props}>
    <FormattedMessage id="button.ok" />
  </Button>
);

export default OkButton;
